// extracted by mini-css-extract-plugin
export default {"quantity_container":"tK","hiddenflavorstring":"uK","loadingLine":"vK","productimgwrap":"wK","productimg":"xK","circlepic":"yK","productinfo":"zK","grey_x":"AK","cartrow":"BK","bold":"CK","title":"EK","blue":"FK","strike":"GK","flexgap":"HK","flavorstring":"IK","nodecorate":"JK","flavorstring_link":"KK","rdstring":"LK","removeditemblock":"MK","removed_heading":"NK","removed_text":"OK","addback":"PK"};
    if(module.hot) {
      // 1715632478110
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  